module.exports = "/_next/static/images/AggregationReverseETL@2x-541cda4113a2230bfae1cd7d63702c63.webp";